import { useEffect, useRef, useState } from "react"
import { Container, Row, Col, Card, Form, Button, InputGroup, Alert } from "react-bootstrap"
import React from "react"
import { ErrorMessage, Field, Formik, FormikProps } from "formik"
import { loginClient } from "App"
import { tokenStorage } from "TokenStorage"
import * as Yup from 'yup'
import ModalRecuperarPassword from "utils/ModalRecuperarPassword"
// import InstalarPWABoton from "utils/InstalarPWABoton"
// import ModalQR2FA from "utils/ModalQR2FA"
import { useBlockUI } from "Context/BlockUIContext"
import { MyForm } from "FormikHooks"
import loginPanelBg from '../Imagenes/bank_logo_light.png'
import { useApi } from "ApiHooks"
import { useErrorModal } from "Context/ErrorModalContext"
import { useLocation } from "react-router"

export default function BankSALogin() {
    const [showPassword, setShowPassword] = useState(false)
    const [mensajeError, setMensajeError] = useState('')
    const [showModalRecuperarPassword, setShowModalRecuperarPassword] = useState(false)
    const [formValues, setFormValues] = useState({
        userName: tokenStorage.getUserName() || '',
        password: tokenStorage.getPassword() || ''
    })
    const formikRef = useRef<FormikProps<any>>(null)
    const api = useApi()
    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const token = params.get('token')
    const { showError } = useErrorModal()
    const { showBlock, hideBlock } = useBlockUI()
    let schema = Yup.object({
        userName: Yup.string().nullable().required('Debe ingresar el nombre de usuario'),
        password: Yup.string().nullable().required('Debe ingresar la contraseña')
    })

    async function login(values: { userName: string, password: string }) {
        setMensajeError('')
        showBlock('Iniciando sesión...')
        setFormValues({ userName: values.userName, password: values.password })
        return loginClient.post('/Login', {
            "usuario": values.userName,
            "password": values.password,
        }).then(respuesta => {
            tokenStorage.setUserName(values.userName)
            tokenStorage.setPassword(values.password)
            tokenStorage.setAccessToken(respuesta.data)
            obtenerEmailUsuario().then((resp) => {
                if (resp) {
                    tokenStorage.setEmailUsuario(resp)
                    showBlock('Iniciando sesión..')
                    window.location.replace('/selectDeclarante')
                    hideBlock()
                } else {
                    tokenStorage.setEmailUsuario('El usuario no tiene email registrado')
                    showBlock('Iniciando sesión..')
                    window.location.replace('/selectDeclarante')
                    hideBlock()
                }
            }).catch(() => {
                tokenStorage.setEmailUsuario('Error al obtener email')
                showBlock('Iniciando sesión..')
                window.location.replace('/selectDeclarante')
                hideBlock()
            })
        }).catch(error => {
            if (error?.response?.status === 401) {
                if (error.response?.data) {
                    setMensajeError('Usuario o contraseña incorrectos')
                    hideBlock()
                }
            } else if (error.response.status === 400) {
                setMensajeError('Ocurrio un error del servidor al procesar la solicitud')
                hideBlock()
                // let mensajesError: any[] = []
                // Object.keys(error.response.data).forEach(key => {
                //     error.response.data[key].forEach((mensaje: any) => mensajesError.push(mensaje))
                // })
                // hideBlock()
                // setMensajeError(mensajesError.join('\r\n'))
            } else {
                hideBlock()
                console.error('Error al iniciar sesion', error)
                setMensajeError('Hubo un error al iniciar sesión')
            }
        }).finally(
        )
    }

    const obtenerEmailUsuario = async () => {
        showBlock("Obteniendo datos del usuario...")
        try {
            return await api.getEmailUsuario()
        } catch (error: any) {
            if (!api.isCancel(error)) {
                showError({
                    title: 'Error al cargar datos del usuario',
                    message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message?.length > 0 ? error?.response?.data?.message : 'Error desconocido del servidor',
                })
            }
        } finally {
            hideBlock()
        }
    }

    function submit(values: { userName: string, password: string }) {
        return login(values)
    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }

    const decodeJWT = (token: string) => {
        try {
            const payload = token.split('.')[1]
            const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
            return JSON.parse(decoded)
        } catch (error) {
            console.error('Token inválido', error)
            return null
        }
    }

    useEffect(() => {
        if (!token) return

        const decodedToken = decodeJWT(token)
        if (!decodedToken) return

        let isMounted = true

        const login = async () => {
            try {
                showBlock('Obteniendo mail usuario..')

                tokenStorage.setUserName(decodedToken.email)
                tokenStorage.setAccessToken(token)
                tokenStorage.setUserName(decodedToken.Usuario)

                const resp = await obtenerEmailUsuario()
                if (!isMounted || !resp) return

                tokenStorage.setEmailUsuario(resp)

                showBlock('Iniciando sesión..')
                window.location.replace('/selectDeclarante')
            } catch (error) {
                console.error('Error durante login automático', error)
            } finally {
                if (isMounted) hideBlock()
            }
        }

        login()

        return () => {
            isMounted = false
        }
        //eslint-disable-next-line    
    }, [token])

    return (
        <div >
            <div className="flex-grow-1 d-flex align-items-center justify-content-center " style={{ marginTop: '10vh' }}>
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={8} md={6} lg={5} xl={4}>
                            <Card className="shadow-lg border-0">
                                <Card.Header className="border-0 text-center pb-3" style={{ paddingTop: "24px", backgroundColor: '#626a71' }}>
                                    <div className="position-relative mb-4" >
                                        <img src={loginPanelBg} style={{ width: '100%', height: 'auto', }} alt="Bank SA" title="Bank SA"></img>
                                        <div
                                            className="position-absolute"
                                            style={{ bottom: "-24px", left: "50%", transform: "translateX(-50%)" }}
                                        >
                                        </div>
                                    </div>
                                    <div className="position-relative my-4">
                                        <hr className="text-muted" style={{ color: "white" }} />
                                    </div>
                                    <Card.Title className="font-weight-bold mb-1" style={{ color: "#ffffff", fontSize: "1.5rem" }}>
                                        Iniciar sesión
                                    </Card.Title>
                                    <p style={{ color: '#ffffff' }}>Ingresa tus credenciales para continuar</p>
                                    {mensajeError?.length > 0 && <Alert variant="danger" >
                                        {mensajeError}
                                    </Alert>}
                                </Card.Header>
                                <Card.Body style={{ padding: "24px" }}>
                                    <Formik
                                        enableReinitialize={true}
                                        initialValues={formValues}
                                        validationSchema={schema}
                                        innerRef={formikRef}
                                        onSubmit={submit}>
                                        <MyForm className="loginForm">
                                            <Form.Group className="mb-4">
                                                <Form.Label className="font-weight-medium text-dark">Usuario</Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="bg-white" style={{ borderColor: "#d1d5db", borderRight: "none" }}>
                                                        <svg width="16" height="16" fill="#4f46e5" viewBox="0 0 24 24">
                                                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                                            <circle cx="12" cy="7" r="4" />
                                                        </svg>
                                                    </InputGroup.Text>
                                                    <Field name="userName">
                                                        {({ field }: import('formik').FieldProps) => (
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Ingresa tu usuario"
                                                                {...field}
                                                                style={{ height: "48px", borderColor: "#d1d5db", borderLeft: "none", fontSize: "16px" }}
                                                            />
                                                        )}
                                                    </Field>
                                                </InputGroup>
                                                <ErrorMessage name="userName">
                                                    {msg => <div className="text-danger mt-1" style={{ fontSize: "14px" }}>{msg}</div>}
                                                </ErrorMessage>
                                            </Form.Group>
                                            <Form.Group className="mb-4">
                                                <Form.Label className="font-weight-medium text-dark">Contraseña</Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="bg-white" style={{ borderColor: "#d1d5db", borderRight: "none" }}>
                                                        <svg width="16" height="16" fill="#4f46e5" viewBox="0 0 24 24">
                                                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                                            <circle cx="12" cy="16" r="1" />
                                                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                                        </svg>
                                                    </InputGroup.Text>
                                                    <Field name="password">
                                                        {({ field }: import('formik').FieldProps) => (
                                                            <Form.Control
                                                                type={showPassword ? "text" : "password"}
                                                                placeholder="Ingresa tu contraseña"
                                                                {...field}
                                                                style={{ height: "48px", borderColor: "#d1d5db", borderLeft: "none", borderRight: "none", fontSize: "16px" }}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Button
                                                        variant="outline-secondary"
                                                        onClick={togglePasswordVisibility}
                                                        style={{
                                                            borderColor: "#d1d5db",
                                                            backgroundColor: "white",
                                                            borderLeft: "none",
                                                        }}
                                                    >
                                                        {showPassword ? (
                                                            <svg width="16" height="16" fill="#4f46e5" viewBox="0 0 24 24">
                                                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                                                <circle cx="12" cy="12" r="3" />
                                                                <path d="M1 1l22 22" />
                                                            </svg>
                                                        ) : (
                                                            <svg width="16" height="16" fill="#4f46e5" viewBox="0 0 24 24">
                                                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                                                <circle cx="12" cy="12" r="3" />
                                                            </svg>
                                                        )}
                                                    </Button>
                                                </InputGroup>
                                                <ErrorMessage name="password">
                                                    {msg => <div className="text-danger mt-1" style={{ fontSize: "14px" }}>{msg}</div>}
                                                </ErrorMessage>
                                            </Form.Group>
                                            <Button
                                                type="submit"
                                                block
                                                className="font-weight-medium shadow"
                                                style={{
                                                    height: "48px",
                                                    backgroundColor: "#4f46e5",
                                                    borderColor: "#4f46e5",
                                                    fontSize: "16px",
                                                }}
                                            >
                                                Iniciar sesión
                                            </Button>
                                        </MyForm>
                                    </Formik >
                                    <div className="position-relative my-4">
                                        <p onClick={() => setShowModalRecuperarPassword(true)} style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline', alignContent: 'center', textAlign: 'center' }}>Recuperar contraseña</p>
                                        <hr className="text-muted" />
                                    </div>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <ModalRecuperarPassword usuario={formikRef?.current?.values?.userName} showModalRecuperarPassword={showModalRecuperarPassword} setShowModalRecuperarPassword={setShowModalRecuperarPassword} handleCloseModalCheckEmail={() => setShowModalRecuperarPassword(false)} />
        </div>
    )
}
